'use strict';

// LPモバイル下部固定CTA（840px以下）のスクロール連動表示。
// ヒーロー内に同一のCTA（.lp-hero__cta）があるため、上部では二重表示になる。
// そこでヒーローのCTAが画面外に出たら（ある程度スクロールしたら）モバイルCTAを表示する。
// IntersectionObserver非対応／対象なしの場合は常時表示にフォールバック。
(function() {
  function init() {
    const bar = document.querySelector('.lp-mobile-cta');
    if (!bar) return;

    const sentinel = document.querySelector('.lp-hero__cta');

    if (!sentinel || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // ヒーローのCTAが見えている間は隠し、画面外に出たら表示する。
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    io.observe(sentinel);
  }

  document.addEventListener('turbolinks:load', init);
})();
